/**
 * Admin views: used by administator to manage application
 * Path: `@/views/admin`
 */

import multiguard from "vue-router-multiguard"
import { requireStaff } from "@/utils/middleware"

const AdminSummary = () => import("@/views/admin/admin/AdminSummary.vue")
const AdminValidation = () => import("@/views/admin/admin/AdminValidation.vue")
const CompaniesPlans = () => import("@/views/admin/admin/CompaniesPlans.vue")
const CompanyPlans = () => import("@/views/admin/admin/CompanyPlans.vue")
const AdminActions = () => import("@/views/admin/admin/AdminActions.vue")
const PartnerCardCreateUpdate = () => import("@/views/admin/partnerCard/PartnerCardCreateUpdate.vue")
const PartnerCards = () => import("@/views/admin/partnerCard/PartnerCards.vue")
const PartnerCompany = () => import("@/views/admin/company/PartnerCompany.vue")
const AdminUsers = () => import("@/views/admin/admin/AdminUsers.vue")
const PhysicalCardsAdmin = () => import("@/views/admin/admin/PhysicalCardsAdmin.vue")
const AdminVouchers = () => import("@/views/admin/admin/AdminVouchers.vue")
const AdminVehicles = () => import("@/views/admin/admin/AdminVehicles.vue")
const AdminActivities = () => import("@/views/admin/admin/AdminActivities.vue")
const AdminOcrCorrected = () => import("@/views/admin/admin/AdminOcrCorrected.vue")
const AdminActivityAdjustments = () => import("@/views/admin/admin/AdminActivityAdjustments.vue")
const AdminDonations = () => import("@/views/admin/admin/AdminDonations.vue")
const AdminAnnouncements = () => import("@/views/admin/admin/AdminAnnouncements.vue")

const AdminDrawer = () => import("@/components/layouts/core/AdminDrawer.vue")

export default [
  {
    path: "/admin",
    name: "Admin",
    redirect: { name: "AdminSummary" }
  },
  {
    path: "/admin/summary",
    component: AdminSummary,
    name: "AdminSummary",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer
    }
  },
  {
    path: "/admin/companies/plans",
    component: CompaniesPlans,
    name: "CompaniesPlans",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer
    }
  },
  {
    path: "/admin/users",
    component: AdminUsers,
    name: "AdminUsers",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer
    }
  },
  {
    path: "/admin/physical-cards",
    component: PhysicalCardsAdmin,
    name: "PhysicalCardsAdmin",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer
    }
  },
  {
    path: "/admin/vourchers",
    component: AdminVouchers,
    name: "AdminVouchers",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer
    }
  },
  {
    path: "/admin/activities",
    component: AdminActivities,
    name: "AdminActivities",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer
    }
  },
  {
    path: "/admin/ocr-corrected",
    component: AdminOcrCorrected,
    name: "AdminOcrCorrected",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer
    }
  },
  {
    path: "/admin/approval",
    component: AdminActivityAdjustments,
    name: "AdminActivityAdjustments",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer
    }
  },
  {
    path: "/admin/donations",
    component: AdminDonations,
    name: "AdminDonations",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer
    }
  },
  {
    path: "/admin/announcements",
    component: AdminAnnouncements,
    name: "AdminAnnouncements",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer,
    },
  },
  {
    path: "/admin/vehicles",
    component: AdminVehicles,
    name: "AdminVehicles",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer
    }
  },
  {
    path: "/admin/company/plans/:id",
    component: CompanyPlans,
    name: "CompanyPlans",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/admin/validations",
    component: AdminValidation,
    name: "AdminValidation",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer
    }
  },
  {
    path: "/admin/actions",
    component: AdminActions,
    name: "AdminActions",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer
    }
  },
  {
    path: "/admin/companies",
    component: PartnerCompany,
    name: "PartnerCompany",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer
    }
  },
  {
    path: "/admin/partners",
    name: "PartnerCards",
    component: PartnerCards,
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer
    }
  },
  {
    path: "/aadmin/partners/:id?/editor",
    name: "PartnerCardCreateUpdate",
    component: PartnerCardCreateUpdate,
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default"
    }
  }
]
